import { Utils } from "@/plugin/gis-viewer/Utils";
import {
  IResult,
  IDrawOverlaysDelete,
  IDrawOverlays,
  IDrawOverlayParameter,
  IFindParameter,
  IPolylineRangingParameter
} from "@/types/map";

declare let ol: any;
export default class DrawOverlaysPGIS {
  private static instances: Map<string, any>;
  private view!: any;
  private fmap!: any;

  public layerGroups: Map<string, any> = new Map<string, any>(); //<type,layer>
  public curDrawedResult: any;

  private drawLayer: any = null;
  private clearLastResult: boolean = false;

  private _drawOverlays: Map<string, any> = new Map<string, any>();
  private _drawingType: string = "";
  private _drawingManager: any = null;
  private _drawStyle: any;

  private _defaultVectorStyle!: any;
  private _callback!: any;
  private _result: any;
  private _type: any;
  private _id: any;
  private _symbol: any;
  private _repeat: any;

  private constructor(view: any, fmap: any) {
    this.view = view;
    this.fmap = fmap;
  }

  public static getInstance(view: any, fmap: any) {
    let id = view.getTarget();
    if (!DrawOverlaysPGIS.instances) {
      DrawOverlaysPGIS.instances = new Map();
    }
    let instance = DrawOverlaysPGIS.instances.get(id);
    if (!instance) {
      instance = new DrawOverlaysPGIS(view, fmap);
      DrawOverlaysPGIS.instances.set(id, instance);
    }
    return instance;
  }

  private async getOverlayLayer(type: string) {
    let layer = this.layerGroups.get(type);
    if (!layer) {
      layer = await this.createOverlayLayer(type);
    }
    return layer;
  }

  private async createOverlayLayer(type: string): Promise<any> {
    this._defaultVectorStyle = new ol.style.Style({
      fill: new ol.style.Fill({
        color: "rgba(255, 255, 255, 0.2)"
      }),
      stroke: new ol.style.Stroke({
        color: "#33ffe0",
        width: 2
      }),
      image: new ol.style.Circle({
        radius: 7,
        fill: new ol.style.Fill({
          color: "#33ffe7"
        })
      })
    });
    //存储原始矢量点、线、面
    const vectorLayer = new ol.layer.Vector({
      source: new ol.source.Vector({}),
      style: this._defaultVectorStyle
    });
    vectorLayer.title = "drawOverlays_layer_" + type;
    this.view.addLayer(vectorLayer);
    this.layerGroups.set(type, vectorLayer);

    return vectorLayer;
  }

  public async startDrawOverlays(
    params: IDrawOverlayParameter
  ): Promise<IResult> {

    if (this._drawingType || this._drawingManager || this.drawLayer) {
      await this.stopDrawOverlays();
    }
    this._drawingType = this.getGeoType(params.drawType);
    if (!this._drawingType) {
      return {
        status: 0,
        message: "please check out the “drawType” properties!"
      };
    }
    this._type = (typeof params.type === "string") ? params.type : "drawOverlays";
    this._id = params.id;
    const onlyOnce = params.onlyOnce || false;
    const generateId =
      typeof params.generateId === "boolean" ? params.generateId : false;

    this.clearLastResult =
      typeof params.clearLastResult === "boolean"
        ? params.clearLastResult
        : false; this._repeat = params.repeat || false;
    this._callback = params.callback;

    this.drawLayer = await this.getOverlayLayer(this._type);

    // if (this.clearLastResult) {
    //   const features = this.drawLayer.getSource().getFeatures();
    //   if (features.length > 0) {
    //     this.drawLayer.getSource().removeFeature(features[features.length - 1]);
    //   }
    // }

    //绘制的符号样式
    this._symbol = params.symbol;
    this._drawStyle = params.symbol ? this.getStyle(params.symbol) : this._defaultVectorStyle;

    let geometryFunction = null;
    let maxPoints = undefined;
    if (params.drawType === "rectangle") {
      maxPoints = 2;
      geometryFunction = ol.interaction.Draw.createBox();
    }

    this._drawingManager = new ol.interaction.Draw({
      source: this.drawLayer.getSource(),
      type: this._drawingType,
      style: this._drawStyle,
      geometryFunction: geometryFunction,
      maxPoints: maxPoints
    });

    this.view.addInteraction(this._drawingManager);

    //@todo 绘制开始时屏蔽地图上的其他点击事件
    let drawPromise = new Promise((resolve) => {
      this.view.once("dblclick", async () => {
        if (onlyOnce) {
          return;
        }
        if (params.drawType === "rectangle" || params.drawType === "circle") {
          return;
        }
        //移除鼠标双击事件
        const dblClickInteraction = this.view
          .getInteractions()
          .getArray()
          .find((interaction: any) => {
            return interaction instanceof ol.interaction.DoubleClickZoom;
          });
        this.view.removeInteraction(dblClickInteraction);
        await this.stopDrawOverlays();
        //恢复鼠标双击事件
        this.view.addInteraction(dblClickInteraction);
        resolve(null);
      });


      this._drawingManager.on("drawend", async (results: any) => {
        //设置覆盖物属性
        let feature = results.feature;
        feature.setProperties({
          id: this._id,
          type: this._type,
          symbol: this._symbol
        });
        feature.setStyle(this._drawStyle);
        if (generateId) {
          feature.id = Math.random()
            .toFixed(5)
            .toString();
        }
        if (!this._repeat) {
          await this.stopDrawOverlays();
        }
        if (this._callback) {
          this.setCallBack(results);
        }
        this.setResult(results);
        resolve(null);
      });

    });

    await drawPromise;

    return {
      status: 0,
      message: "成功调用startDrawOverlays方法!获取覆盖物请调用getDrawOverlays",
      result: this._result,
    };
  }

  public async deleteDrawOverlays(
    params: IDrawOverlaysDelete
  ): Promise<IResult> {
    await this.stopDrawOverlays();
    let delCount = 0;

    if (!this.drawLayer) {
      return {
        status: 0,
        message: "成功调用deleteDrawOverlays方法!,无覆盖物可删除！"
      };
    }
    const layerSource = this.drawLayer.getSource();

    if (!params) {
      delCount = layerSource.getFeatures().length;
      layerSource.clear();
      return {
        status: 0,
        message: "成功调用deleteDrawOverlays方法!",
        result: delCount ? `成功删除${delCount}个覆盖物！` : "未删除任何覆盖物"
      };
    }

    const ids = params.ids || [];
    const types = params.types || [];

    const features = layerSource.getFeatures();
    for (let feature of features) {
      if (
        //只判断type
        (types.length > 0 &&
          ids.length === 0 &&
          types.indexOf(feature.getProperties().type) >= 0) ||
        //只判断id
        (types.length === 0 &&
          ids.length > 0 &&
          ids.indexOf(feature.getProperties().id) >= 0) ||
        //type和id都要判断
        (types.length > 0 &&
          ids.length > 0 &&
          types.indexOf(feature.getProperties().type) >= 0 &&
          ids.indexOf(feature.getProperties().id) >= 0)
      ) {
        layerSource.removeFeature(feature);
        delCount++;
      }
    }

    return {
      status: 0,
      message: "成功调用deleteDrawOverlays方法!",
      result: delCount ? `成功删除${delCount}个覆盖物！` : "未删除任何覆盖物"
    };
  }

  public async stopDrawOverlays(): Promise<IResult> {
    if (this._drawingManager) {
      this._drawingManager.finishDrawing();
      this.view.removeInteraction(this._drawingManager);
      this._drawingManager = null;
    }
    this._drawingType = "";
    return {
      status: 0,
      message: "成功调用停止绘画方法!"
    };
  }

  //获取地图上所有绘制要素
  public async getDrawOverlays(): Promise<IResult> {
    const returnResults = await this.getDrawResults();
    return {
      status: 0,
      message: "成功调用改方法！",
      result: { dataJson: JSON.stringify(returnResults), data: returnResults },
    };
  }

  private getStyle(params: any): any {
    const symbol = params;
    let vectorStyle: any = new ol.style.Style({
      fill: new ol.style.Fill({
        color: "rgba(255, 255, 255, 0.2)"
      }),
      stroke: new ol.style.Stroke({
        color: "#33ffe0",
        width: 2
      }),
      image: new ol.style.Circle({
        radius: 7,
        fill: new ol.style.Fill({
          color: "#33ffe7"
        })
      })
    });
    switch (symbol.type) {
      case "point":
        if (symbol.primitive) {
          const radius = symbol.size || 7;
          const color = symbol.color || "#33ffe7";
          vectorStyle.getImage().setRadius(radius);
          vectorStyle
            .getImage()
            .getFill()
            .setColor(color);
        } else {
          const src = symbol.url;
          const size: any = symbol.size || [];
          const offset: any = [symbol.xoffset, symbol.yoffset] || [];
          if (!src || typeof src !== "string") {
            return {
              status: 0,
              message: "点url属性错误！"
            };
          }
          const img = new ol.style.Icon({
            src: src
          });
          if (size.length && typeof size[0] === "number") {
            let picSize = img.getSize();
            picSize = size;
            vectorStyle.setImage(img);
          }
          if (offset.length && typeof offset[0] === "number") {
            img.offset = offset;
            vectorStyle.setImage(img);
          }
        }
        break;
      case "polyline":
        const color = symbol.color;
        const width = symbol.width;
        const plStroke = new ol.style.Stroke({
          color: "#33ffe7",
          width: 5
        });

        if (color) {
          plStroke.setColor(color);
          vectorStyle.setStroke(plStroke);
        }
        if (width) {
          plStroke.setWidth(width);
          vectorStyle.setStroke(plStroke);
        }
        break;
      case "polygon":
        const polygonColor = symbol.color;
        const outline = symbol.outline;

        const olStroke = new ol.style.Stroke({
          color: "rgb(0,0,0)",
          width: 0.1
        });
        const fill = new ol.style.Fill({
          color: "rgba(0,208,254,0.5)"
        });
        if (outline && outline.color) {
          olStroke.setColor(outline.color);
          vectorStyle.setStroke(olStroke);
        }
        if (outline && outline.width) {
          olStroke.setWidth(outline.width);
          vectorStyle.setStroke(olStroke);
        }
        if (polygonColor) {
          fill.setColor(polygonColor);
          vectorStyle.setFill(fill);
        }
        break;
      default:
        break;
    }
    return vectorStyle;
  }

  private getGeoType(param: any) {
    let lowerCase = param.toLowerCase();
    let drawType = lowerCase;
    switch (lowerCase) {
      case "point":
        drawType = "Point";
        break;
      case "polyline":
        drawType = "MultiLineString";
        break;
      case "polygon":
        drawType = "Polygon";
        break;
      case "rectangle":
        drawType = "Circle";
        break;
      case "circle":
        drawType = "Circle";
        break;
      default:
        break;
    }

    return drawType;
  }

  private async getDrawResults(): Promise<any> {
    if (!this.drawLayer) {
      return false;
    }
    const features = this.drawLayer.getSource().getFeatures();
    const results: any = [];
    features.forEach((feature: any) => {
      const result: any = {};

      let extent = feature.getGeometry().getExtent();
      let center = ol.extent.getCenter(extent);
      let geoType = this.formatGeoType(feature.getGeometry().getType());
      let coordinates = feature.getGeometry().getCoordinates();

      let geo = {
        coordinates: coordinates,
        type: geoType,
        extent: extent,
        center: center,
        centroid: center,
        //与arcgis保持同样的参数
        paths: geoType == "polyline" ? coordinates : [],
        rings: geoType == "polygon" ? coordinates : [],
      }
      result.geometry = geo;

      if (geoType === "circle") {
        result.geometry.center = feature.getGeometry().getCenter();
        result.geometry.radius = feature.getGeometry().getRadius();
      }

      let props = feature.getProperties();
      let fields = {
        id: props.id,
        type: props.type || "drawOverlays",
      }
      result.fields = fields;
      result.id = props.id;
      result.style = feature.getStyle();
      result.symbol = props.symbol;

      results.push(result);
    });
    return { type: "drawOverlays", overlays: results };
  }

  private setCallBack(results: any) {
    const feature = results.feature;
    let coordinates = feature.getGeometry().getCoordinates();
    let geoType_ = feature.getGeometry().getType();
    let geoType: string = this.formatGeoType(geoType_);
    let style = feature.getStyle();

    let symbol = feature.getProperties().symbol;
    let extent = feature.getGeometry().getExtent();
    let center = ol.extent.getCenter(extent);

    // let polygoncenter = ;//多边形中心
    let geo = {
      coordinates: coordinates,
      type: geoType,
      extent: extent,
      center: center,
      centroid: center,
      //与arcgis保持同样的参数
      paths: geoType == "polyline" ? coordinates : [],
      rings: geoType == "polygon" ? coordinates : [],
    }
    this._callback({
      center: center,
      geometry: geo,
      data: {
        type: this._type,
        overlays: [{
          geometry: geo,
          fields: {
            id: this._id,
            type: this._type,
          },
          id: this._id,
          symbol: symbol,
          style: style,
        },
        ],
      },
    });
  }

  ////这一坨后续需要确定格式
  private setResult(results: any) {
    const feature = results.feature;
    const geoName = feature.getGeometry().getType();
    let callbackResult: any = {};
    callbackResult.id = feature.getProperties().id; //此时的值应与this._id相同
    callbackResult.type = feature.getProperties().type;
    callbackResult.geometry = {};
    callbackResult.geometry.type = geoName;
    callbackResult.overlay = feature.getGeometry();
    if (geoName.toLowerCase() === "circle") {
      callbackResult.geometry.center = feature.getGeometry().getCenter();
      callbackResult.geometry.radius = feature.getGeometry().getRadius();
    } else {
      callbackResult.geometry.coordinates = feature
        .getGeometry()
        .getCoordinates();
    }
    let attrs = feature.getProperties();
    callbackResult.attributes = attrs;
    this._result = callbackResult;
    this.curDrawedResult = callbackResult;
  }

  //将几何类型统一化,与arcgis保持一致
  private formatGeoType(type: any): string {
    switch (type) {
      case "Point":
        return "point";
      case "LineString":
        return "polyline";
      case "Polygon":
        return "polygon";
      case "Circle":
        return "circle";

      case "LinearRing":
      case "MultiPoint":
      case "MultiLineString":
        return "polyline";
      case "MultiPolygon":
      case "GeometryCollection":
      default:
        break;
    }
    return "";
  }
}
